module.exports = __webpack_public_path__ + "static/media/b.c93d8734.jpg";